// Class: motion.easing._Quart.QuartEaseIn

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var QuartEaseIn = function() {
}

// Meta

QuartEaseIn.__name__ = ["motion","easing","_Quart","QuartEaseIn"];
QuartEaseIn.__isInterface__ = false;
QuartEaseIn.__interfaces__ = [(motion_easing_IEasing().default)];
QuartEaseIn.prototype = {
	calculate: function(k) {
		return k * k * k * k;
	},
	ease: function(t,b,c,d) {
		return c * (t /= d) * t * t * t + b;
	}
};
QuartEaseIn.prototype.__class__ = QuartEaseIn.prototype.constructor = $hxClasses["motion.easing._Quart.QuartEaseIn"] = QuartEaseIn;

// Init



// Statics




// Export

exports.default = QuartEaseIn;